import React from 'react';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Toggle from '@amzn/meridian/toggle';
import { useTranslation } from 'src/arb-wrapper';

interface FormAbTestingControlsProps {
  isEnabled: boolean;
  variationCount: number;
  onToggle: (enabled: boolean) => void;
  onVariationChange: (count: number) => void;
  disabled?: boolean;
}

export const FormAbTestingControls: React.FC<FormAbTestingControlsProps> = ({
  isEnabled,
  variationCount,
  onToggle,
  onVariationChange,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const maxVariants = parseInt('25', 10) || 25;

  return (
    <Column spacing="200">
      <Column spacing="100">
        <Row alignmentHorizontal="justify" alignmentVertical="center" spacing="400">
          <Column spacing="100">
            <Text type="b200">{t('ab_testing_toggle_label')}</Text>
            <Toggle
              checked={isEnabled}
              data-testid="ab-testing-toggle"
              disabled={disabled}
              onChange={(checked: boolean) => {
                onToggle(checked);
                if (!checked) {
                  onVariationChange(2);
                }
              }}
            >
              {isEnabled ? t('ab_testing_enabled') : t('ab_testing_disabled')}
            </Toggle>
          </Column>
          {isEnabled && (
            <Column spacing="100">
              <Text type="b200">{t('ab_testing_variations_label')}</Text>
              <Row alignmentVertical="center" spacing="200">
                <div style={{ position: 'relative', width: '200px', height: '20px' }}>
                  <input
                    data-testid="ab-testing-slider"
                    disabled={disabled}
                    max={maxVariants}
                    min={2}
                    style={{
                      width: '100%',
                      height: '4px',
                      background: '#e0e0e0',
                      outline: 'none',
                      borderRadius: '2px',
                      appearance: 'none',
                      cursor: disabled ? 'not-allowed' : 'pointer',
                    }}
                    type="range"
                    value={variationCount}
                    onChange={(e) => {
                      onVariationChange(parseInt(e.target.value, 10));
                    }}
                  />
                  <style>
                    {`
                      input[type="range"]::-webkit-slider-thumb {
                        appearance: none;
                        width: 16px;
                        height: 16px;
                        border-radius: 50%;
                        background: #0073bb;
                        cursor: pointer;
                      }
                      input[type="range"]::-moz-range-thumb {
                        width: 16px;
                        height: 16px;
                        border-radius: 50%;
                        background: #0073bb;
                        cursor: pointer;
                        border: none;
                      }
                    `}
                  </style>
                </div>
                <Text>{variationCount} {t('ab_testing_variations_suffix')}</Text>
              </Row>
            </Column>
          )}
        </Row>
        {isEnabled && (
          <Text color="secondary">
            {t('ab_testing_explanation')}
          </Text>
        )}
      </Column>
    </Column>
  );
};
